export { default } from './SEO';
export type { SEOProps, SEOClassKey, SEOClasses } from './SEO.types';
